import { render, staticRenderFns } from "./ElevateVideos.vue?vue&type=template&id=714f707a&scoped=true"
import script from "./ElevateVideos.vue?vue&type=script&lang=js"
export * from "./ElevateVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f707a",
  null
  
)

export default component.exports